import React from 'react';
import Ratings from '../../../components/Ratings';
import { getDDMMYYYY } from '../../../Functions/dates';
import userImg from '../../../images/user.png';

const PreCanCVs2 = React.forwardRef((props, ref) => {
    let candidate = props?.candidate;

    return (
        <div className='p-5' ref={ref}>
            <div className="border">
                <div className="p-5">
                    <div className="row">
                        <div className="col-3 text-center">
                            <img alt="" className="rounded-circle" src={candidate?.user?.pimg || userImg} />
                        </div>
                        <div className="col-9">
                            <h4 className="text-primary">{candidate?.user?.fullname}</h4>
                            <i className="fa fa-phone" /> +{candidate?.profile?.mobile}<br />
                            <b>Date of Birth: </b> {getDDMMYYYY(candidate?.profile?.dob)}<br />
                            <b>Gender: </b> {candidate?.profile?.gender}<br />
                            <i className="fa fa-envelope" />&nbsp;&nbsp;<u><a href={`mailto:${candidate?.user?.email}`}>{candidate?.user?.email}</a></u><br />
                            {candidate?.online && <><i className="fa fa-facebook-square" aria-hidden="true" />&nbsp;&nbsp;
                                <a href={candidate?.online?.facebook || '#'} target="_blank" rel="noopener noreferrer">{candidate?.online?.facebook}</a></>}<br />
                            <i className="fa fa-address-card" /> {candidate?.profile?.address}, {candidate?.profile?.city}, {candidate?.profile?.country}, {candidate?.profile?.zipcode}
                        </div>
                    </div>
                    <div className="mt-3 mb-3">
                        <h5 className="text-primary mb-0">ABOUT ME</h5><hr className="mt-0 mb-1" style={{ borderTop: "1px solid #0000005e" }} />
                        {candidate?.profile?.aboutme}<br />
                    </div>
                    <div className="mb-3">
                        {candidate?.education && <><h5 className='mb-0 text-primary'>EDUCATION AND QUALIFICATION</h5><hr className="mt-0 mb-1" style={{ borderTop: "1px solid #0000005e" }} /></>}
                        {candidate?.education && <h6>{candidate?.education?.school} - {candidate?.education?.per}%</h6>}
                        {
                            candidate?.degrees && candidate?.degrees.map(degree =>
                                <>
                                    <h6 className="mb-0"><b>{degree?.degree__name}</b></h6>
                                    {degree?.percentage}% - {degree?.university_name}<br />
                                </>
                            )
                        }
                    </div>
                    {
                        candidate?.career_interest && <div className="mb-3">
                            <h5 className='mb-0 text-primary'>CAREER INTEREST</h5><hr className="mt-0 mb-1" style={{ borderTop: "1px solid #0000005e" }} />
                            <h6 className='mb-0'>{candidate?.career_interest?.current_level}</h6>
                            Job Categories: <b>{candidate?.career_interest?.job_categories?.join(', ')}</b><br />
                            Job Titles: <b>{candidate?.career_interest?.job_titles?.join(', ')}</b><br />
                            Job Types: <b>{candidate?.career_interest?.job_types?.join(', ')}</b><br />
                            Interested Places to work: <b>{candidate?.career_interest?.place_to_work?.join(', ')}</b>
                        </div>
                    }
                    {
                        candidate?.experiences?.length > 0 && <div className="mb-3">
                            <h5 className='mb-0 text-primary'>EXPERIENCES</h5><hr className="mt-0 mb-1" style={{ borderTop: "1px solid #0000005e" }} />
                            <div className="row p-2">
                                {
                                    candidate?.experiences.map(exp =>
                                        <div className="col-6 card p-3">
                                            <h6 className='mb-0'><b><i>{exp?.job_title__name}</i></b></h6>
                                            {exp?.designation} in {exp?.company_name}&nbsp;&nbsp;
                                            <span><i className="fa fa-map-marker" />&nbsp;{exp?.country__name}, &nbsp;&nbsp;
                                                <i className="fa fa-clock-o" />&nbsp;{getDDMMYYYY(exp?.started_from)} to {getDDMMYYYY(exp?.ended_on)}</span>
                                            <span><i className="fa fa-globe" />&nbsp;<a href={exp?.company_website || '#'} target="_blank" rel="noopener noreferrer" className="text-secondary">{exp?.company_website}</a></span>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    }
                    {
                        candidate?.languages?.length > 0 && <div className="mb-3">
                            <h5 className='mb-0 text-primary'>LANGUAGE SKILLS</h5><hr className="mt-0 mb-1" style={{ borderTop: "1px solid #0000005e" }} />
                            <div className="row p-2">
                                {
                                    candidate?.languages.map(lan =>
                                        <div className="col-6 card p-3">
                                            <h6 className='mb-0 mr-auto ml-auto'><b><i>{lan?.language__name}</i></b></h6>
                                            <div className="d-flex justify-content-between">
                                                <span className="d-flex align-items-center"> Reading: &nbsp;<Ratings edit={false} stars={5} value={lan?.reading} /></span>
                                                <span />
                                                <span className="d-flex align-items-center"> Writing: &nbsp;<Ratings edit={false} stars={5} value={lan?.writing} /></span>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                                <span className="d-flex align-items-center"> Listening: &nbsp;<Ratings edit={false} stars={5} value={lan?.listening} /></span>
                                                <span />
                                                <span className="d-flex align-items-center"> Speaking: &nbsp;<Ratings edit={false} stars={5} value={lan?.speaking} /></span>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    }
                    {
                        candidate?.skills?.length > 0 && <div className="mb-3">
                            <h5 className='mb-0 text-primary'>SKILLS</h5><hr className="mt-0 mb-1" style={{ borderTop: "1px solid #0000005e" }} />
                            <div className="row p-2">
                                {
                                    candidate?.skills.map(skill =>
                                        <div className="col-6 card p-3">
                                            <h6 className='mb-0 text-center'><b><i>{skill?.skill__name}</i></b></h6>
                                            <div className="d-flex justify-content-between">
                                                <span>Proficiency: {skill?.proficiency}/5</span>
                                                <span>Experience: {skill?.experience}/5</span>
                                                <span>Interest: {skill?.interest}/5</span>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    }
                    {
                        candidate?.trainings?.length > 0 && <div className="mb-3">
                            <h5 className='mb-0 text-primary'>TRAININGS</h5><hr className="mt-0 mb-1" style={{ borderTop: "1px solid #0000005e" }} />
                            <div className="row p-2">
                                {
                                    candidate?.trainings.map(tr =>
                                        <div className="col-6 card p-3">
                                            <h6 className='mb-0 text-center'><b><i>{tr?.topic}</i></b></h6>
                                            <span>Institution: {tr?.insti_name}</span>
                                            <span>Year: {tr?.year}</span>
                                            <span>Addi. Info: {tr?.addi_info}</span>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
});

export default PreCanCVs2;